import { render, staticRenderFns } from "./minimization.vue?vue&type=template&id=a0008172"
import script from "./minimization.vue?vue&type=script&lang=js"
export * from "./minimization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports